var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navChange"},[_c('div',{staticClass:"navigation"},[_c('span',{class:{active: _vm.activeType ==='video'},on:{"click":function($event){return _vm.changeType('video')}}},[_vm._v("视频中心")]),_c('span',{class:{active: _vm.activeType ==='img'},on:{"click":function($event){return _vm.changeType('img')}}},[_vm._v("高清壁纸")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }